module.exports = __webpack_public_path__ + "static/img/anjiesi.8aef393.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/phone/anjiesi.jpg
// module id = peuZ
// module chunks = 1